import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import MobileShell from './components/MobileShell';

/**
 * Vista mobile del perfil propio. Datos clave + accesos rápidos en filas
 * tipo iOS settings (chevron a la derecha). Foto grande arriba, logout
 * abajo del todo en rojo claro.
 */
const MENU = [
  { path: '/m/album',        icon: 'photo_library',  label: 'Mi álbum' },
  { path: '/m/reservations', icon: 'shopping_bag',   label: 'Mis compraventas' },
  { path: '/m/communities',  icon: 'groups',          label: 'Mis comunidades' },
  { path: '/profile',        icon: 'edit',            label: 'Editar perfil (web)' },
];

export default function MobileProfile() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  if (!user) {
    navigate('/login');
    return null;
  }
  return (
    <MobileShell title="Perfil">
      <section className="px-5 pt-6 pb-4 flex flex-col items-center">
        <div className="w-24 h-24 rounded-3xl bg-primary-container flex items-center justify-center text-3xl font-black text-on-primary-container">
          {(user.name || '?').charAt(0).toUpperCase()}
        </div>
        <h1 className="mt-3 text-xl font-black text-on-surface">{user.name}</h1>
        {user.username && <p className="text-sm text-on-surface-variant">@{user.username}</p>}
      </section>

      <section className="px-5 pb-4">
        <div className="bg-surface-container rounded-xl overflow-hidden divide-y divide-outline-variant/40">
          {MENU.map(item => (
            <button
              key={item.path}
              type="button"
              onClick={() => navigate(item.path)}
              className="w-full flex items-center gap-3 px-4 min-h-[52px] text-left bg-transparent border-0 appearance-none cursor-pointer active:bg-surface-container-high"
            >
              <span className="material-symbols-outlined text-on-surface-variant">{item.icon}</span>
              <span className="flex-1 text-base font-bold text-on-surface">{item.label}</span>
              <span className="material-symbols-outlined text-on-surface-variant">chevron_right</span>
            </button>
          ))}
        </div>
      </section>

      <section className="px-5 pb-12">
        <button
          type="button"
          onClick={() => { logout?.(); navigate('/m'); }}
          className="w-full min-h-[52px] rounded-xl border border-red-300 text-red-600 font-bold text-sm bg-surface"
        >
          Cerrar sesión
        </button>
      </section>
    </MobileShell>
  );
}
